/* eslint-disable @next/next/no-css-tags */
/* eslint-disable @next/next/no-img-element */
import Head from 'next/head';
import Link from 'next/link';

import styles from '../styles/elements/CookieStyles.module.scss';

import { sanityClient, PortableText } from '../lib/sanity';

import WhiteBlueIllustration from '../components/elements/WhiteBlueIllustration';
import NumberedCopyBlock from '../components/elements/NumberedCopyBlock';
import IntroCopyBlock from '../components/elements/IntroCopyBlock';
import Spacer from '../components/elements/Spacer';

import StandardLayout from '../components/layouts/StandardLayout';
import GreenQuote from '../components/GreenQuote';

const FoodQuery = `
{"FoodPageInfoQuery": *[_id=="d585eaa6-c07a-4b5b-9e51-c8c34874e475"] {
  title,
  meta,
  introheading,
  introcopy,
  pagequote,
  pinkmessage,
  paragraphs,
  customblocks,
  headerimage,
},
  "companyInfoQuery" : *[_type=="company"] {
    overlaytitle,
    message,
    title,
    footer,
    sociallinks,
    email,
    numbers
  },
  "nurseryQuery" : *[_type=="nurseries"] {
    address,
    linkaddress,
    "manuscriptURL": manuscript.asset->url,
    mapimage
  }
}
`;

export default function Food({ FoodPageInfoQuery, companyInfoQuery, nurseryQuery }) {
  const PageInfo = FoodPageInfoQuery[0];
  const Company = companyInfoQuery;
  const Nurseries = nurseryQuery;
  const PageQuote = PageInfo.pagequote;

  return (
    <>
      <StandardLayout CompanyInfo={Company} Nurseries={Nurseries} PageInfo={PageInfo} headerWidth={1920} headerHeight={600} headerMinHeight={300} hideLeadImage={false}>
        <div className={styles.mainContent}>
          <div className="container">
            <IntroCopyBlock PageInfo={PageInfo} />

            <Spacer mt={4} />
            <div className={styles.cookieinfo}>
              <div className="Cookie"><b>Cookie</b></div>
              <div className="Name"><b>Name</b></div>
              <div className="Purpose"><b>Purpose</b></div>
              <div className="c2">Cookie Message</div>
              <div className="n2">cookie_message</div>
              <div className="p2">Saves a message to let us know that you have seen our cookie message</div>
              <div className="c3">Google Analytics</div>
              <div className="n3">
                _utma
                <br />
                _utmb
                <br />
                _utmc
                <br />
                _utmz
              </div>
              <div className="p3">These cookies are used to collect information about how visitors use our site. We use the information to compile reports and to help us improve the site. The cookies collect information in an anonymous form, including the number of visitors to the site, where visitors have come to the site from and the pages they visited.</div>
            </div>
              <div className={styles.optout}>The table below explains the cookies we use and why. To opt out of being tracked by Google Analytics across all websites visit <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a></div>
          </div>
        </div>
        {PageQuote && <GreenQuote quote={PageQuote} />}
        <WhiteBlueIllustration />
      </StandardLayout>
    </>
  );
}

export async function getStaticProps() {
  const { FoodPageInfoQuery, companyInfoQuery, peopleInfoQuery, nurseryQuery } = await sanityClient.fetch(FoodQuery);
  return { props: { FoodPageInfoQuery, companyInfoQuery, nurseryQuery } };
}
